<template>
  <div class="priceArea">
    <div
      v-for="(item, index) in initArr"
      :key="index"
      :class="[
        {
          'number-item': !isNaN(item),
          'mark-item': isNaN(item)
        },
        itemClass(initArr, index)
      ]"
      :style="itemStyle(initArr, index)"
    >
      <div class="num-box">
        <ul ref="numberItem" :class="['num-list', { noTrans: isNaN(item) }]">
          <template v-if="!isNaN(item)">
            <li v-for="(n, i) in nums" :key="`${index + '-' + i}`">{{ n }}</li>
          </template>
          <template v-else>
            <li class="comma">{{ item }}</li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import create from '../create'
export default create({
  name: 'price-animate',
  props: {
    oldPrice: {
      type: [Number, String],
      required: true,
      default: '0.00'
    },
    newPrice: {
      type: [Number, String],
      required: true,
      default: '0.00'
    },
    itemStyle: {
      type: Function,
      default: () => {}
    },
    itemClass: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      initArr: [],
      // 需要2段0-9，第一段用于原价初始化下翻，第二段用于新价继续下翻
      nums: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      timer: null
    }
  },
  watch: {
    newPrice: {
      handler() {
        let num = this.newPriceFloat.length - this.initArr.length
        if (num > 0) {
          for (let i = 0; i < num; i++) {
            this.initArr.unshift('0')
          }
        }
        this.timer = setTimeout(() => {
          this.initArr = this.setPriceArr(this.newPriceFloat)
          this.numScroll(this.initArr)
        }, 0)
      }
    }
  },
  computed: {
    setPriceArr() {
      return function (num) {
        return num.split('')
      }
    },
    oldPriceFloat() {
      return (+this.oldPrice).toFixed(2)
    },
    newPriceFloat() {
      return (+this.newPrice).toFixed(2)
    }
  },
  created() {
    this.initArr = this.setPriceArr(this.oldPriceFloat)
  },
  mounted() {
    // 初始化原价
    this.numScroll(this.initArr, true)

    // 现价，延时800ms翻动
    this.timer = setTimeout(() => {
      this.initArr = this.setPriceArr(this.newPriceFloat)
      this.numScroll(this.initArr)
    }, 800)
  },
  methods: {
    numScroll(initArr, isInit) {
      const numberItems = this.$refs.numberItem
      for (let index = 0; index < numberItems.length; index++) {
        const num = Number(initArr[index])
        const elem = numberItems[index]

        let oldPriceFloat = this.oldPriceFloat
        let newPriceFloat = this.newPriceFloat
        if (oldPriceFloat.length > newPriceFloat.length) {
          newPriceFloat = newPriceFloat.padStart(oldPriceFloat.length, '0')
        }
        if (isInit) {
          // 初始化原价，translateY按最小值下翻，预留新价继续下翻的空间
          elem.style.transform = `translateY(-${num * 10}%)`
        } else {
          if (oldPriceFloat[index] !== newPriceFloat[index]) {
            // 价格变动，下翻
            elem.style.transform = `translateY(-${(num + 10) * 10}%)`
          } else {
            // 价格未变动，不翻
            elem.style.transform = `translateY( -${num * 10}%)`
          }
        }
      }
      // 处理整数位数减少时,小数点位移的问题
      this.$nextTick(() => {
        document.querySelector('.noTrans').style.transform = `translateY(0)`
      })
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer)
    this.timer = null
  }
})
</script>

<style lang="scss" src="./index.scss"></style>
